export const NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES = {
  normal: false,
  notNormal: false,
  declined: false,
  normalDetails: [],
  notNormalDetails: [],
  notes: "",
};

export const EARS_FORM_INITIAL_VALUES = {
  sections: {
    generalAppearanceEars: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
    positionEars: NEWBORN_POSTPARTUM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type NewbornPostpartumPhysicalExamsEarsSections =
  keyof typeof EARS_FORM_INITIAL_VALUES.sections;
